<template>
    <div class="view-content page-home">
        <QRAndBg />
        <!-- 绘本 & 产品服务 -->
        <BookAnServiceDesc />
        <BookReadingSymtem />
        <!-- 海量内容 -->
        <BookNumberDesc />

        <BooksDesc />

        <CourseDesc />

        <StoryDesc />
        <!-- 分龄分级 -->
        <!-- <AgeGrading /> -->
        <!-- 宝贝收获 & 合作伙伴 -->
        <!-- <CollectAndPartner /> -->
        <ContactUs :whiteBg="false"/>
    </div>
</template>

<script>
import QRAndBg from './QRAndBg'
import BookAnServiceDesc from './BookAnServiceDesc'
import BookReadingSymtem from './BookReadingSymtem'
import BookNumberDesc from './BookNumberDesc'
// import AgeGrading from './AgeGrading'
import CollectAndPartner from './CollectAndPartner'
import ContactUs from '@/components/m-connect-us/m-connect-us'
import BooksDesc from './BooksDesc.vue'
import CourseDesc from './CourseDesc.vue'
import StoryDesc from './StoryDesc.vue'
export default {
    name: "home",
    components: {
        QRAndBg,
        BookAnServiceDesc,
        BookNumberDesc,
        // AgeGrading,
        CollectAndPartner,
        ContactUs,
        BookReadingSymtem,
        BooksDesc,
        CourseDesc,
        StoryDesc
    },
    created() {
        window.scrollTo(0,0)
        this.$sendBehavior('pv_204001')
    },
}
</script>

<style lang="stylus">
@import "../../style/vui/mixins"
.page-home
    background #ffffff
/* 添加媒体查询，针对iphone5以下小屏设备样式 */
@media (max-width 320px)
    .connect-us-cont
        .contact
            &-us
            &-copyright
                font-size px2rem2(12)
            &-us
                padding-left px2rem2(14)
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue